'use client';

import { c as _c } from "react/compiler-runtime";
import type { GetStudentMentoringStateOutputDTO } from '@algoacademy/backend/modules/payment/endpoints/queries/get-student-mentoring-state/output.dto';
import { ChangeBlockedNotice } from './_components/ChangeBlockedNotice';
import { ChangeSubscriptionFlow } from './_components/ChangeSubscriptionFlow';
import { IssueOfferFlow } from './_components/IssueOfferFlow';
type FormActionsProps = {
  isChangeMode: boolean;
  isBlocked: boolean;
  isLookupPending: boolean;
  isUpsertPending: boolean;
  isChangePending: boolean;
  mentoringState: GetStudentMentoringStateOutputDTO | undefined;
  current: NonNullable<GetStudentMentoringStateOutputDTO['current']> | null;
  onOpenConfirm: () => void;
};
export function FormActions(t0) {
  const $ = _c(9);
  const {
    isChangeMode,
    isBlocked,
    isLookupPending,
    isUpsertPending,
    isChangePending,
    mentoringState,
    current,
    onOpenConfirm
  } = t0;
  if (isChangeMode && current !== null) {
    let t1;
    if ($[0] !== isChangePending || $[1] !== onOpenConfirm) {
      t1 = <ChangeSubscriptionFlow isPending={isChangePending} onOpenConfirm={onOpenConfirm} />;
      $[0] = isChangePending;
      $[1] = onOpenConfirm;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (isBlocked && current !== null && mentoringState !== undefined) {
    const t1 = mentoringState.subscriptionState === "cancelled" ? "cancelled" : "unpaidRenewal";
    let t2;
    if ($[3] !== current.renewsAt || $[4] !== t1) {
      t2 = <ChangeBlockedNotice reason={t1} renewsAt={current.renewsAt} />;
      $[3] = current.renewsAt;
      $[4] = t1;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  if (isChangeMode || isBlocked) {
    return null;
  }
  let t1;
  if ($[6] !== isLookupPending || $[7] !== isUpsertPending) {
    t1 = <IssueOfferFlow isLookupPending={isLookupPending} isPending={isUpsertPending} />;
    $[6] = isLookupPending;
    $[7] = isUpsertPending;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}